export function getPartyName(party) {
  return party ? party.name : 'Not available'
}
